import { observer } from 'mobx-react-lite'
import Migrations from './migrations/Migrations'
import { useState } from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import StorageIcon from '@mui/icons-material/Storage'
import BackupTableIcon from '@mui/icons-material/BackupTable'
import FeatureToggle from './feature-toggle/FeatureToggle'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import DeleteIcon from '@mui/icons-material/Delete'
import DevDeleteOrg from './delete-org/DevDeleteOrg'
import DevGoose from './goose/DevGoose'
import PetsIcon from '@mui/icons-material/Pets'
import OAuthClientList from './oauth-clients/OAuthClientList'
import SecurityIcon from '@mui/icons-material/Security'
import PostgresMigrations from './postgres-migrations/PostgresMigrations'

export default observer(function DevSettings() {
   const [value, setValue] = useState(0)

   const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue)
   }

   return <>
      <Tabs value={value} onChange={handleChange} sx={{ mb: 6 }}>
         <Tab icon={<StorageIcon />} label="Migrations" />
         <Tab icon={<BackupTableIcon />} label="PostgreSQL" />
         <Tab icon={<ToggleOnIcon />} label="Feature toggle" />
         <Tab icon={<SecurityIcon />} label="OAuth clients" />
         <Tab icon={<DeleteIcon />} label="Delete org" />
         <Tab icon={<PetsIcon />} label="Goose" />
      </Tabs>
      {value === 0 && <Migrations />}
      {value === 1 && <PostgresMigrations />}
      {value === 2 && <FeatureToggle />}
      {value === 3 && <OAuthClientList />}
      {value === 4 && <DevDeleteOrg />}
      {value === 5 && <DevGoose />}
   </>
})
